import React, { ReactElement, useEffect, useState } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Spacing } from '../../style'

import { Button } from '../button'

import RadioSquare from './square'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  square: {
    marginLeft: Spacing.XS,
  },
  squareFirst: {
    marginLeft: 0,
  },
})

export interface Option<T = string> {
  value: T
  title?: string | ReactElement
  onHoverIn?: () => void
  onHoverOut?: () => void
  disabled?: boolean
}

export interface Props<T> extends ViewProps {
  value?: T
  items?: Option<T>[]
  onSelect?: (value: T) => void
  error?: boolean
  disabled?: boolean
  round?: boolean
  optionStyle?: StyleProp<ViewStyle>
  optionContentContainerStyle?: StyleProp<ViewStyle>
}
const RadioGroup = (props: Props<any>) => {
  const {
    value,
    items,
    onSelect,
    error,
    disabled,
    round,
    style,
    optionStyle,
    optionContentContainerStyle,
    ...otherProps
  } = props

  const [option, setOption] = useState(items?.find((opt) => opt.value === value))

  useEffect(() => {
    setOption(items?.find((opt) => opt.value === value))
  }, [props.value])

  const select = (option: Option) => () => {
    setOption(option)
    onSelect && onSelect(option.value)
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {items?.map((groupOption, index) => (
        <RadioSquare
          key={groupOption?.value}
          style={[index === 0 ? styles.squareFirst : styles.square, optionStyle]}
          contentContainerStyle={optionContentContainerStyle}
          title={groupOption.title || groupOption.value}
          selected={groupOption.value === option?.value}
          onPress={select(groupOption)}
          round={round}
          error={!!error}
          disabled={disabled || groupOption.disabled}
          onHoverIn={groupOption.onHoverIn}
          onHoverOut={groupOption.onHoverOut}
        />
      ))}
    </View>
  )
}

interface SkeletonProps extends ViewProps {
  numberOfOptions?: number
  optionStyle?: StyleProp<ViewStyle>
}
RadioGroup.Skeleton = (props: SkeletonProps) => {
  const { numberOfOptions = 3, optionStyle, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {Array.from({ length: numberOfOptions }).map((_, index) => (
        <Button.Skeleton
          key={`skeleton-${index}`}
          style={[index === 0 ? styles.squareFirst : styles.square, optionStyle]}
        />
      ))}
    </View>
  )
}

export default RadioGroup
